import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import TrendsComponent from "@/pages/trends/TrendComponents/Trends/TrendsComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useSearchParams } from "react-router-dom";
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import { PageNamesEnum } from "@/routes/routes";
var Trends = function Trends() {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var currentPage = parseInt(searchParams.get("page") || "1");
  var data = useFullPageData(PageNamesEnum.PAGE_NAME__Trend);
  if (!data) return null;
  var trendsList = data.trendsList,
    trendsPagination = data.trendsPagination;
  var totalPages = (trendsPagination === null || trendsPagination === void 0 ? void 0 : trendsPagination.total_pages) || 1;
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true
  }, /*#__PURE__*/React.createElement(TrendsComponent, {
    trendsList: trendsList,
    totalPages: +totalPages,
    currentPage: +currentPage
  }));
};
export default Trends;